import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ClickMore extends React.PureComponent {
    static propTypes = {
        link: PropTypes.string,
    };

    /**
     * 渲染组件
     */
    render() {
        const { link } = this.props;

        return (
            <div className={styles.link}>
                <a href={link} target="_blank" rel="noreferrer">查看更多</a>
            </div>
        );
    }
}

export default errorBoundary(ClickMore);
